import axios from "axios";
import { OrganizationURL } from "../../../config/UrlEndPoint";

export const URL = `${OrganizationURL}topup`;

// items => filtered/sorted result for table data
export function findTopUpInvoice(queryParams) {
  return axios.post(`${URL}/get_invoice_list`, queryParams);
}

// POST => POST: Create the topUp on the server
export function createTopUpInvoice(topUp) {
  return axios.post(`${URL}/create_invoice`, topUp);
}

export function getDetailInvoice(id) {
  return axios.get(`${URL}/get_invoice/${id}`);
}

export const createTopUpPayment = (payload) => {
  return axios.post(`${URL}/create_payment`, payload);
};
